import afterTransition from '../helpers/afterTransition';

export default {
    when() {
        return document.querySelectorAll('.collapse-toggle').length > 0;
    },

    collapses: [],

    mounted() {
        document.querySelectorAll('.collapse-toggle').forEach((button) => {
            this.collapses.push(new Collapse(button, button.dataset));
        });
    },

    destroy() {
        this.collapses.forEach((collapse) => {
            collapse.unbind();
        });
    },
};

class Collapse {
    constructor(button, options = {}) {
        this.button = button;
        this.options = {
            container: button.dataset.container || '.collapse-container',
            target: button.dataset.target,
            ...options,
        };
        this.container = this.button.closest(this.options.container);
        this.collapse = document.getElementById(this.options.target);
        this.isVisible = this.collapse.classList.contains('open');
        this.isTransitioning = false;

        this.bind();
    }

    bind() {
        this.button.addEventListener('click', (e) => this.handleClick(e), true);
        document.body.addEventListener('collapseHideAll', () => this.hide());
    }

    handleClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        this.toggle(!this.isVisible);
    }

    hide() {
        if (this.isTransitioning || !this.isVisible) {
            return;
        }

        this.collapse.style.height = `${this.collapse.getBoundingClientRect().height}px`;
        this.container.classList.add('transitioning');
        this.container.classList.remove('open');
        this.isTransitioning = true;

        const complete = () => {
            this.isTransitioning = false;
            this.container.classList.remove('transitioning');
            this.button.setAttribute('aria-expended', false);
            this.isVisible = false;
        };

        afterTransition(complete, this.collapse, true);
        this.collapse.style.height = '';
    }

    show() {
        if (this.isTransitioning || this.isVisible) {
            return;
        }

        this.collapse.style.height = 0;
        this.container.classList.add('transitioning');
        this.isTransitioning = true;

        const complete = () => {
            this.isTransitioning = false;
            this.container.classList.remove('transitioning');
            this.container.classList.add('open');
            this.collapse.style.height = '';
            this.button.setAttribute('aria-expended', true);
            this.isVisible = true;
        };

        afterTransition(complete, this.collapse, true);
        this.collapse.style.height = `${this.collapse.scrollHeight}px`;
    }

    toggle(force = null) {
        const condition = force !== null ? force : !this.isVisible;

        if (condition) {
            this.show();
        } else {
            this.hide();
        }
    }

    unbind() {
        this.button.removeEventListener('click', (e) => this.handleClick(e));
        document.body.removeEventListener('collapseHideAll', () => this.hide());
    }
}
